import { useQuery } from '@tanstack/react-query';
import { LoadedUser } from '../../interfaces';
import { getCustomerOverview } from '../../services/user';
import useUser from '../global/useUser';

function useGetCustomerOverview(
  customerId: string | null,
  {
    enabled = true,
  }: {
    enabled?: boolean;
  } = {},
) {
  const { user } = useUser<LoadedUser>();

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isPlaceholderData,
  } = useQuery({
    queryKey: [
      'customer-overview',
      { customerId, businessId: user?.business.id },
    ],
    queryFn: async () => {
      const result = await getCustomerOverview(customerId!, user?.business.id!);
      return result;
    },
    enabled: !!customerId && !!user && !!enabled,
    // no cache - get fresh data every time
    gcTime: 0,
    staleTime: 0,
  });

  return {
    data: isPlaceholderData ? null : data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isPlaceholderData,
  };
}

export default useGetCustomerOverview;
